var video_viewer_default = {
  "video_player": "Uw0dT",
  "videoOverlay": "J-Gfc",
  "video_container": "sHEgk"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
